import type * as Types from '../../graphql/base-types.graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GqlCompanySubscriptionQueryVariables = Types.Exact<{
  companyId: Types.Scalars['ID']['input'];
}>;


export type GqlCompanySubscriptionQuery = { companySubscription?: { id: string, status: Types.GqlStripeSubscriptionStatus, companyId: string, products: any, isActive: boolean, canUseProFeatures: boolean, mainProductName: string } | null };


export const CompanySubscriptionDocument = gql`
    query CompanySubscription($companyId: ID!) {
  companySubscription(companyId: $companyId) {
    id
    status
    companyId
    products
    isActive
    canUseProFeatures
    mainProductName
  }
}
    `;

/**
 * __useCompanySubscriptionQuery__
 *
 * To run a query within a React component, call `useCompanySubscriptionQuery` and pass it any options that fit your needs.
 * When your component renders, `useCompanySubscriptionQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCompanySubscriptionQuery({
 *   variables: {
 *      companyId: // value for 'companyId'
 *   },
 * });
 */
export function useCompanySubscriptionQuery(baseOptions: Apollo.QueryHookOptions<GqlCompanySubscriptionQuery, GqlCompanySubscriptionQueryVariables> & ({ variables: GqlCompanySubscriptionQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GqlCompanySubscriptionQuery, GqlCompanySubscriptionQueryVariables>(CompanySubscriptionDocument, options);
      }
export function useCompanySubscriptionLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GqlCompanySubscriptionQuery, GqlCompanySubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GqlCompanySubscriptionQuery, GqlCompanySubscriptionQueryVariables>(CompanySubscriptionDocument, options);
        }
export function useCompanySubscriptionSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GqlCompanySubscriptionQuery, GqlCompanySubscriptionQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GqlCompanySubscriptionQuery, GqlCompanySubscriptionQueryVariables>(CompanySubscriptionDocument, options);
        }
export type CompanySubscriptionQueryHookResult = ReturnType<typeof useCompanySubscriptionQuery>;
export type CompanySubscriptionLazyQueryHookResult = ReturnType<typeof useCompanySubscriptionLazyQuery>;
export type CompanySubscriptionSuspenseQueryHookResult = ReturnType<typeof useCompanySubscriptionSuspenseQuery>;
export type CompanySubscriptionQueryResult = Apollo.QueryResult<GqlCompanySubscriptionQuery, GqlCompanySubscriptionQueryVariables>;